import { FC, lazy } from 'react';
import { graphql, useFragment } from 'react-relay';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';

import { PdpSharedDealerDetailsReviewContainerLazy_seller$key } from './__generated__/PdpSharedDealerDetailsReviewContainerLazy_seller.graphql';

type Props = { seller: PdpSharedDealerDetailsReviewContainerLazy_seller$key; isMobile?: boolean };

const PdpSharedDealerDetailsReviewContainer = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedDealerDetailsReviewContainer" */ './PdpSharedDealerDetailsReviewContainer'
        )
);

export const PdpSharedDealerDetailsReviewContainerLazy: FC<Props> = ({
    seller: sellerRef,
    isMobile,
}) => {
    const seller = useFragment(
        graphql`
            fragment PdpSharedDealerDetailsReviewContainerLazy_seller on Seller {
                ...PdpSharedDealerDetailsReviewContainer_seller
            }
        `,
        sellerRef
    );

    return (
        <ClientSuspense fallback={null}>
            <PdpSharedDealerDetailsReviewContainer seller={seller} isMobile={isMobile} />
        </ClientSuspense>
    );
};
